import {useFormikContext} from 'formik';
import {useSelector} from 'react-redux';
import InputList from '../../../component/input/inputList/InputList';
import {updateEventSettings} from '../../../redux/event/eventActions';
import {bounceMessage} from '../../../layout/userMessages/UserMessage';

const customerConfirmationActivate = [{key: 'manual', text: 'sendManual'},{key: 'amount', text: 'amount'}, {key: 'time', text: 'time'}];

const CustomerConfirmationInputList = ({name, t, settingsXHR}) => {
    const {setFieldValue, values} = useFormikContext();
    const suspended = useSelector(state => state.event.settings?.suspended||{});

    const handleChange = (name, key) => {
        const currentValue = values[name];
        if(suspended.customerConfirmationAutoSent === 1) {
            bounceMessage(
                t('confirmChangeCustomerConfirmation'),
                'attention',
                {text: t('confirm'), onClick: () => {updateEventSettings(name, key, 'suspended');}},
                {text: t('cancel'),onClick: () => {setFieldValue(name, currentValue);}}
            );
        } else {
            updateEventSettings(name, key, 'suspended');
        }
    };

    return (
        <InputList
            name={name}
            list={customerConfirmationActivate}
            onChange={handleChange}
            className={settingsXHR?.customerConfirmationActivateXHR}
            t={t}
            width={'160px'}
            listProps={{isFixed: true}}
        />
    );
};

export default CustomerConfirmationInputList;
